module.exports = __webpack_public_path__ + "img/camera.df56063f.svg";